import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SocialFeed = () => {
  const [activeTab, setActiveTab] = useState('instagram');

  const socialPosts = {
    instagram: [
      {
        id: 1,
        image: "https://images.unsplash.com/photo-1529042410759-befb1204b468?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        caption: "Fresh lamb kebabs straight from our grill! 🔥 The perfect blend of Mediterranean spices and tender meat. #KebabPalace #FreshGrilled",
        likes: 234,
        comments: 18,
        timestamp: "2 hours ago"
      },
      {
        id: 2,
        image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        caption: "Today\'s special: Mediterranean mezze platter with homemade hummus, fresh pita, and seasonal vegetables 🥙✨",
        likes: 189,
        comments: 12,
        timestamp: "5 hours ago"
      },
      {
        id: 3,
        image: "https://images.unsplash.com/photo-1544025162-d76694265947?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        caption: "Behind the scenes: Chef Mehmet preparing our signature spice blend that makes every dish special 👨‍🍳",
        likes: 156,
        comments: 8,
        timestamp: "1 day ago"
      },
      {
        id: 4,
        image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        caption: "Family dinner vibes at Kebab Palace! Nothing brings people together like authentic Mediterranean food 👨‍👩‍👧‍👦❤️",
        likes: 298,
        comments: 24,
        timestamp: "2 days ago"
      }
    ],
    facebook: [
      {
        id: 1,
        type: "event",
        title: "Mediterranean Cooking Class",
        description: "Join Chef Mehmet this Saturday for a hands-on cooking class! Learn to make authentic kebabs and traditional sides.",
        date: "This Saturday, 2:00 PM",
        attendees: 24,
        interested: 67
      },
      {
        id: 2,
        type: "review",
        reviewer: "Sarah Johnson",
        rating: 5,
        text: "Absolutely incredible experience! The lamb kebabs were perfectly seasoned and the service was outstanding. Our server Amira gave excellent wine recommendations. Will definitely be back!",
        timestamp: "3 days ago"
      },
      {
        id: 3,
        type: "announcement",
        title: "New Vegan Menu Items",
        description: "We\'re excited to announce our expanded vegan menu! Try our new plant-based kebabs, dairy-free baklava, and fresh Mediterranean salads.",
        timestamp: "1 week ago",
        reactions: 45
      }
    ]
  };

  const socialStats = [
    { platform: "Instagram", followers: "12.5K", icon: "Instagram", color: "bg-gradient-to-r from-pink-500 to-purple-600" },
    { platform: "Facebook", followers: "8.2K", icon: "Facebook", color: "bg-blue-600" },
    { platform: "Twitter", followers: "3.1K", icon: "Twitter", color: "bg-blue-400" },
    { platform: "TikTok", followers: "5.8K", icon: "Video", color: "bg-black" }
  ];

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="text-center">
        <h2 className="font-headline text-3xl font-bold text-text-primary mb-4">
          Follow Our Culinary Journey
        </h2>
        <p className="font-body text-lg text-text-secondary max-w-3xl mx-auto">
          Stay connected with daily specials, behind-the-scenes moments, and the vibrant community 
          that makes Kebab Palace special. Join our social media family!
        </p>
      </div>

      {/* Social Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {socialStats.map((stat, index) => (
          <div key={index} className={`${stat.color} text-white p-6 rounded-xl shadow-warm text-center`}>
            <Icon name={stat.icon} size={32} className="mx-auto mb-3" />
            <div className="font-headline text-2xl font-bold mb-1">
              {stat.followers}
            </div>
            <div className="text-sm opacity-90">
              {stat.platform} Followers
            </div>
          </div>
        ))}
      </div>

      {/* Social Feed Tabs */}
      <div className="flex justify-center space-x-4">
        <button
          onClick={() => setActiveTab('instagram')}
          className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-body font-medium transition-organic ${
            activeTab === 'instagram' ?'bg-gradient-to-r from-pink-500 to-purple-600 text-white shadow-warm' :'text-text-primary hover:text-primary hover:bg-primary-50'
          }`}
        >
          <Icon name="Instagram" size={20} />
          <span>Instagram</span>
        </button>
        <button
          onClick={() => setActiveTab('facebook')}
          className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-body font-medium transition-organic ${
            activeTab === 'facebook' ?'bg-blue-600 text-white shadow-warm' :'text-text-primary hover:text-primary hover:bg-primary-50'
          }`}
        >
          <Icon name="Facebook" size={20} />
          <span>Facebook</span>
        </button>
      </div>

      {/* Instagram Feed */}
      {activeTab === 'instagram' && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {socialPosts.instagram.map((post) => (
            <div key={post.id} className="bg-surface rounded-xl shadow-warm overflow-hidden group hover:shadow-warm-lg transition-organic">
              <div className="relative aspect-square overflow-hidden">
                <Image
                  src={post.image}
                  alt="Instagram post"
                  className="w-full h-full object-cover group-hover:scale-105 transition-organic"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-organic"></div>
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-2">
                  <Icon name="Instagram" size={16} className="text-pink-500" />
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-text-secondary mb-3 line-clamp-3">
                  {post.caption}
                </p>
                <div className="flex items-center justify-between text-xs text-text-secondary">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-1">
                      <Icon name="Heart" size={14} className="text-red-500" />
                      <span>{post.likes}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="MessageCircle" size={14} />
                      <span>{post.comments}</span>
                    </div>
                  </div>
                  <span>{post.timestamp}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Facebook Feed */}
      {activeTab === 'facebook' && (
        <div className="space-y-6">
          {socialPosts.facebook.map((post) => (
            <div key={post.id} className="bg-surface rounded-xl shadow-warm p-6">
              {post.type === 'event' && (
                <div className="flex items-start space-x-4">
                  <div className="bg-blue-100 p-3 rounded-lg">
                    <Icon name="Calendar" size={24} className="text-blue-600" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-cta font-semibold text-lg text-text-primary mb-2">
                      {post.title}
                    </h3>
                    <p className="text-text-secondary mb-3">{post.description}</p>
                    <div className="flex items-center space-x-6 text-sm text-text-secondary">
                      <div className="flex items-center space-x-1">
                        <Icon name="Clock" size={14} />
                        <span>{post.date}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Users" size={14} />
                        <span>{post.attendees} attending</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Star" size={14} />
                        <span>{post.interested} interested</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {post.type === 'review' && (
                <div className="flex items-start space-x-4">
                  <div className="bg-accent-100 p-3 rounded-lg">
                    <Icon name="Star" size={24} className="text-accent-600" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-2">
                      <h3 className="font-cta font-semibold text-lg text-text-primary">
                        {post.reviewer}
                      </h3>
                      <div className="flex space-x-1">
                        {[...Array(post.rating)].map((_, i) => (
                          <Icon key={i} name="Star" size={14} className="text-accent-600 fill-current" />
                        ))}
                      </div>
                    </div>
                    <p className="text-text-secondary mb-2">{post.text}</p>
                    <span className="text-xs text-text-secondary">{post.timestamp}</span>
                  </div>
                </div>
              )}

              {post.type === 'announcement' && (
                <div className="flex items-start space-x-4">
                  <div className="bg-conversion-100 p-3 rounded-lg">
                    <Icon name="Megaphone" size={24} className="text-conversion-600" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-cta font-semibold text-lg text-text-primary mb-2">
                      {post.title}
                    </h3>
                    <p className="text-text-secondary mb-3">{post.description}</p>
                    <div className="flex items-center space-x-4 text-sm text-text-secondary">
                      <div className="flex items-center space-x-1">
                        <Icon name="Heart" size={14} />
                        <span>{post.reactions} reactions</span>
                      </div>
                      <span>{post.timestamp}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Follow Us CTA */}
      <div className="bg-gradient-to-r from-primary-500 to-secondary-600 text-white rounded-xl p-8 text-center">
        <h3 className="font-headline text-2xl font-bold mb-4">
          Join Our Social Community
        </h3>
        <p className="text-white/90 mb-6 max-w-2xl mx-auto">
          Be the first to see daily specials, cooking tips, and exclusive behind-the-scenes content. 
          Follow us on your favorite platform and become part of the Kebab Palace family!
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="https://instagram.com/kebabpalace"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-pink-500 to-purple-600 text-white font-cta font-semibold px-6 py-3 rounded-lg shadow-warm hover:shadow-warm-lg transition-organic inline-flex items-center space-x-2"
          >
            <Icon name="Instagram" size={20} />
            <span>Follow on Instagram</span>
          </a>
          <a
            href="https://facebook.com/kebabpalace"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 text-white font-cta font-semibold px-6 py-3 rounded-lg shadow-warm hover:shadow-warm-lg transition-organic inline-flex items-center space-x-2"
          >
            <Icon name="Facebook" size={20} />
            <span>Like on Facebook</span>
          </a>
          <a
            href="https://twitter.com/kebabpalace"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-400 text-white font-cta font-semibold px-6 py-3 rounded-lg shadow-warm hover:shadow-warm-lg transition-organic inline-flex items-center space-x-2"
          >
            <Icon name="Twitter" size={20} />
            <span>Follow on Twitter</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SocialFeed;